import { render, staticRenderFns } from "./BookingEdit.vue?vue&type=template&id=c45dbe06&scoped=true&"
import script from "./BookingEdit.vue?vue&type=script&lang=ts&"
export * from "./BookingEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c45dbe06",
  null
  
)

export default component.exports